import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutComponent } from './logout.component';
import { LogoutRoutingModule } from './logout-routing.module';
import { MaterialModule } from 'components';

@NgModule({
  declarations: [LogoutComponent],
  exports: [LogoutComponent],
  imports: [CommonModule, LogoutRoutingModule, MaterialModule]
})
export class LogoutModule { }
